import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { IamService } from '../../service';

export type AccessKeyRotationConfig = typeof AccessKeyRotationConfig._.Config;

export const AccessKeyRotationConfig = IntegrationConfig.make({
  service: IamService,
  name: Integration_Handler_Names_Enum.AccessKeyRotation,
  configSchema: z.object({
    rotationDays: z.number(),
    userNamePatternFilter: patternFilterSchema.optional(),
  }),
});
